import React from 'react'
import { AsyncMultiPick, type AsyncMultiPickProps, type MultiPickOption } from '@duck/ui'
import { apis } from '@/modules/apiClients'

export interface OrganizationDataInputProps extends Omit<AsyncMultiPickProps, 'mode' | 'fetchOptions'> {
  /** Max number of results to return from the backend. Default: 20. */
  maxResults?: number
}

/**
 * Shared organization search -> options mapper, reused by both the generic data input
 * and any filters that need async organization search.
 */
export const fetchOrganizationOptions = async (
): Promise<MultiPickOption[]> => {
  const { data } = await apis.partnerService.organizationsGet()

  return data.data.map((org) => ({
    value: org.id ?? '',
    label: `${org.name} (${org.type})`,
  }))
}

export const OrganizationDataInput: React.FC<OrganizationDataInputProps> = ({
  maxResults = 20,
  ...props
}) => {

  return (
    <AsyncMultiPick
      mode="preload"
      fetchOptions={fetchOrganizationOptions}
      {...props}
    />
  )
}

